import api from "../api/api";

import store, { history } from "../store";

//Redux types
import {
  GET_UNREAD_NOTIFICATIONS,
  GET_ALL_NOTIFICATIONS,
  GET_UNREAD_NOTIFICATIONS_ERROR,
  GET_ALL_NOTIFICATIONS_ERROR,
  RESET_ALL_NOTIFICATIONS,
  APPEND_NOTIFICATIONS,
  SET_HAS_MORE_NOTIFICATIONS,
  GET_NOTIFICATION_BY_ID,
  GET_NOTIFICATION_BY_ID_ERROR,
} from "./types";

//Set query
export const getUnreadNotifications = () => async (dispatch) => {
  try {
    const res = await api.get("/notifications");
    dispatch({
      type: GET_UNREAD_NOTIFICATIONS,
      payload: {
        unread: res.data.unread,
      },
    });
  } catch (error) {
    console.log(error);
    dispatch({ type: GET_UNREAD_NOTIFICATIONS_ERROR });
  }
};

export const getAllNotifications = () => async (dispatch) => {
  try {
    const res = await api.get("/notifications/open");

    dispatch({
      type: GET_ALL_NOTIFICATIONS,
      payload: {
        notifications: res.data,
      },
    });
  } catch (error) {
    console.log(error);
    dispatch({ type: GET_ALL_NOTIFICATIONS_ERROR });
  }
};

export const resetAllNotifications = () => (dispatch) => {
  dispatch({
    type: RESET_ALL_NOTIFICATIONS,
  });
};

// Fetch a page of notifications (for infinite scroll)
export const fetchNotificationsPage =
  (skip = 0, limit = 20) =>
  async (dispatch) => {
    try {
      const res = await api.get(`/notifications?skip=${skip}&limit=${limit}`);
      dispatch({
        type: APPEND_NOTIFICATIONS,
        payload: {
          notifications: res.data.notifications,
          hasMore: res.data.hasMore,
          total: res.data.total,
          unread: res.data.unread,
          failures: res.data.failures, // For debugging/analytics, not display
        },
      });
    } catch (error) {
      console.log(error);
      // Optionally handle error state
    }
  };

// Fetch a single notification by ID
export const fetchNotificationById = (notificationId) => async (dispatch) => {
  try {
    const res = await api.get(`/notifications/${notificationId}`);
    dispatch({
      type: GET_NOTIFICATION_BY_ID,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    console.log(error);
    dispatch({ type: GET_NOTIFICATION_BY_ID_ERROR });
    throw error;
  }
};
